// extracted by mini-css-extract-plugin
export default {"container":"CTA_container__f2lRk","question":"CTA_question__UVodi","calltoaction":"CTA_calltoaction__FnfKf"};